import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DxButtonModule, DxContextMenuModule, DxDrawerModule, DxListModule, DxLoadPanelModule, DxScrollViewModule, DxToolbarModule, DxTreeViewModule, NestedOptionHost } from 'devextreme-angular';
import { ScreenService } from '../../services/screen.service';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { HhsgLayoutComponent } from './layout/layout.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { HuronSideNavigationMenuComponent } from './side-navigation-menu/side-navigation-menu.component';
import { HuronUserMenuComponent } from './user-menu/user-menu.component';

@NgModule({
    declarations: [
        FooterComponent,
        HeaderComponent,
        HhsgLayoutComponent,
        NotificationsComponent,
        HuronSideNavigationMenuComponent,
        HuronUserMenuComponent
    ],
	imports: [
        DxButtonModule,
        CommonModule,
        DxToolbarModule,
        RouterModule,
        DxDrawerModule, 
        DxScrollViewModule,
        DxTreeViewModule,
        DxListModule,
        DxContextMenuModule,
        DxLoadPanelModule
    ],
	exports: [
        FooterComponent,
        HeaderComponent,
        HhsgLayoutComponent,
        NotificationsComponent,
        HuronSideNavigationMenuComponent,
        HuronUserMenuComponent
    ],
    providers: [
        ScreenService,
        NestedOptionHost 
    ]
}) 
export class HhsgSharedLayoutModule {
}
